import {
  CurrencyCode,
  formatCurrency,
  GiftCardStatus,
  IGiftCardResponse,
} from '@one-tree/library'
import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { RoutePath } from '../../../../types/Routes'
import ResultTableRow from './ResultTableRow'
import Timeline from './Timeline'

const StyledResultTableRow = styled(ResultTableRow)`
  th {
    padding-top: 14px;
  }
`
type Props = {
  giftCard: IGiftCardResponse
  currencyCode?: CurrencyCode
}
export default function ValueRow(props: Props): ReactElement {
  const {
    giftCard: {
      redemptionValue,
      value,
      status,
      redemptionHistory,
      salePrice,
      promotion,
    },
    currencyCode,
  } = props

  const redeemed = status === GiftCardStatus.Redeemed
  const hasHistory = redemptionHistory && redemptionHistory.length
  const actualValue = redeemed && redemptionValue ? redemptionValue : value
  const isPartial = redemptionValue !== value

  const PromotionLink = promotion ? (
    <>
      <Link to={`${RoutePath.ManagePromotions}/${promotion.id}`}>
        {promotion.name}
      </Link>
      <span>{promotion.wording ? ` (${promotion.wording})` : ''}</span>
    </>
  ) : null

  return (
    <>
      <ResultTableRow
        title={redeemed && isPartial ? 'Value redeemed' : 'Value'}
        value={actualValue ? formatCurrency(actualValue, currencyCode) : 0}
      />

      {(salePrice || salePrice === 0) && salePrice !== value ? (
        <ResultTableRow
          title="Sale price"
          value={salePrice ? formatCurrency(salePrice, currencyCode) : 'Free'}
        />
      ) : null}

      {promotion?.name && salePrice !== value ? (
        <ResultTableRow title="Promotion" value={PromotionLink} />
      ) : null}

      {redeemed && redemptionValue && isPartial ? (
        <ResultTableRow
          title="Original value"
          value={formatCurrency(value, currencyCode)}
        />
      ) : null}

      {hasHistory && (
        <StyledResultTableRow
          title="Timeline"
          value={(
            <Timeline
              redemptionHistory={redemptionHistory}
              currencyCode={currencyCode}
            />
          )}
        />
      )}
    </>
  )
}
